import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "filterForm",
    "clientHint",
    "validationMessage",
    "submit",
    "priorityBody", "priorityChevron",
    "msoBody", "msoChevron",
    "taskerBody", "taskerChevron"
  ]

  connect() {
    this.restoreSectionStates()
  }

  clientChanged(event) {
    const clientId = event.target.value

    if (this.hasClientHintTarget) {
      this.clientHintTarget.classList.toggle("hidden", clientId !== "")
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = (clientId === "")
    }

    const form = this.hasFilterFormTarget ? this.filterFormTarget : this.element.querySelector("form")
    if (!form) return

    const formData = new FormData(form)
    const params = new URLSearchParams(formData)

    fetch(`/reports/filter_options?${params.toString()}`, {
      headers: { "Accept": "text/vnd.turbo-stream.html" }
    })
    .then(response => response.text())
    .then(html => Turbo.renderStreamMessage(html))
  }

  onSubmit() {
    // Allow natural form submission
  }

  toggleSection(event) {
    const section = event.params.section
    this.applySectionToggle(section)
  }

  restoreSectionStates() {
    this.applySectionState("priority", "priorityBody", "priorityChevron", true)
    this.applySectionState("mso", "msoBody", "msoChevron", true)
    this.applySectionState("tasker", "taskerBody", "taskerChevron", false)
  }

  applySectionState(sectionName, bodyName, chevronName, defaultOpen) {
    const bodyTarget = `${bodyName}Target`
    const chevronTarget = `${chevronName}Target`
    const hasBody = `has${bodyName.charAt(0).toUpperCase() + bodyName.slice(1)}Target`

    if (!this[hasBody]) return

    const key = `indie_cut_in_report_${sectionName}_open`
    let isOpen = defaultOpen
    try {
      const stored = sessionStorage.getItem(key)
      if (stored !== null) isOpen = stored === "1"
    } catch (_) {}

    this[bodyTarget].classList.toggle("hidden", !isOpen)
    this[chevronTarget].textContent = isOpen ? "▼" : "►"
  }

  applySectionToggle(sectionName) {
    const bodyName = `${sectionName}Body`
    const chevronName = `${sectionName}Chevron`
    const bodyTarget = `${bodyName}Target`
    const chevronTarget = `${chevronName}Target`
    const hasBody = `has${bodyName.charAt(0).toUpperCase() + bodyName.slice(1)}Target`

    if (!this[hasBody]) return

    const isHidden = this[bodyTarget].classList.contains("hidden")
    this[bodyTarget].classList.toggle("hidden", !isHidden)
    this[chevronTarget].textContent = isHidden ? "▼" : "►"

    try {
      const key = `indie_cut_in_report_${sectionName}_open`
      sessionStorage.setItem(key, isHidden ? "1" : "0")
    } catch (_) {}
  }
}
